import { Component, ChangeDetectorRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { GenericBulkUpsertLandingComponent } from '../../shared/containers/generic-bulk-upsert-landing.component';
import { GenericBulkUpsertService } from '../../shared/services/generic-bulk-upsert.service';
import { ZIPCODE_BULK_UPSERT_FIELDS } from '../models/zipcode-bulk-upsert.model';
import { GenericBulkUpsertFeatureState } from '../../shared/store';

@Component({
  selector: 'zipcode-bulk-upsert-landing',
  templateUrl: '../../shared/containers/generic-bulk-upsert-landing.component.html'
})
export class ZipcodeBulkUpsertLandingComponent extends GenericBulkUpsertLandingComponent {
  title = 'Zip Code';
  validateEndpoint = 'api/zipcodes/bulk/validate';
  uploadEndpoint = 'api/zipcodes/bulk/upload';
  fields = ZIPCODE_BULK_UPSERT_FIELDS;
  templateFilename = 'zipcode_bulk_upsert_template.csv';

  constructor(
    protected store: Store<GenericBulkUpsertFeatureState>, 
    protected cdr: ChangeDetectorRef,
    protected genericService: GenericBulkUpsertService
  ) {
    super(store, cdr, genericService);
  }
}
